import modules from "./modules";
import { createStore } from "vuex";

export default createStore({
  modules,
});
